"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Container = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
const {
  colours,
  spacing
} = _uiKit.theme;
const Container = exports.Container = _styledComponents.default.div.withConfig({
  displayName: "Liststyle__Container",
  componentId: "sc-dkhkh6-0"
})(["width:100%;border-top:1px solid ", ";"], colours.NEUTRALS_5);
const Wrapper = exports.Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Liststyle__Wrapper",
  componentId: "sc-dkhkh6-1"
})(["padding:", ";"], spacing.BASE_1);